import { useTranslation } from 'react-i18next';

import { NAMESPACE_TRANSLATION } from 'internationalise';
import {
  getUnitQuizDescription,
  getUnitQuizLabel,
} from '../logic/content-label';

export const useDifferentiationTranslation = () => {
  const { t } = useTranslation(NAMESPACE_TRANSLATION);

  return {
    unitQuizLabel: getUnitQuizLabel(t),
    unitQuizDescription: getUnitQuizDescription(t),
  };
};
